<template>
  <div class="pa-4" style="background-color: #F4F7FE; min-height: 100vh;">
    
    <v-card class="mb-6 pa-5 rounded-xl elevation-2 border-0 bg-white">
      <v-row align="center">
        <v-col cols="12" md="4">
          <div class="text-h5 font-weight-black deep-blue--text">Panel de Control Live Fit</div>
          <div class="text-caption grey--text font-weight-bold text-uppercase">
            Bienvenido, {{ nombreUsuario }}
          </div>
        </v-col>

        <v-col cols="6" md="2">
          <v-select v-model="mesSeleccionado" :items="listaMeses" label="Mes" hide-details outlined dense color="#4318FF" class="rounded-lg"></v-select>
        </v-col>

        <v-col cols="6" md="2">
          <v-select v-model="anioSeleccionado" :items="listaAnios" label="Año" hide-details outlined dense color="#4318FF" class="rounded-lg"></v-select>
        </v-col>
        
        <v-col cols="12" md="4" class="text-right">
          <v-menu offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#4318FF" dark large v-bind="attrs" v-on="on" class="rounded-lg px-8 font-weight-black elevation-3">
                <v-icon left>mdi-file-chart</v-icon> GENERAR REPORTES <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list class="py-0">
              <v-menu offset-x open-on-hover transition="slide-x-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-icon><v-icon color="primary">mdi-cash-register</v-icon></v-list-item-icon>
                    <v-list-item-title>Membresías (Pagos)</v-list-item-title>
                    <v-list-item-action><v-icon small>mdi-chevron-right</v-icon></v-list-item-action>
                  </v-list-item>
                </template>
                <v-list class="py-0">
                  <v-list-item @click="generarReporte('Pagos', 'excel')"><v-list-item-title>Excel</v-list-item-title></v-list-item>
                  <v-list-item @click="generarReporte('Pagos', 'pdf')"><v-list-item-title>PDF</v-list-item-title></v-list-item>
                </v-list>
              </v-menu>
              <v-divider></v-divider>
              <v-menu offset-x open-on-hover transition="slide-x-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-icon><v-icon color="orange darken-4">mdi-store</v-icon></v-list-item-icon>
                    <v-list-item-title>Tienda</v-list-item-title>
                    <v-list-item-action><v-icon small>mdi-chevron-right</v-icon></v-list-item-action>
                  </v-list-item>
                </template>
                <v-list class="py-0">
                  <v-list-item @click="generarReporte('Ventas', 'excel')"><v-list-item-title>Excel</v-list-item-title></v-list-item>
                  <v-list-item @click="generarReporte('Ventas', 'pdf')"><v-list-item-title>PDF</v-list-item-title></v-list-item>
                </v-list>
              </v-menu>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card>

    <cartas-personalizadas :cartas="datosVisitas" />
    <v-row class="mt-2 mb-8">
      <v-col cols="12" sm="6" lg="4" v-for="(g, i) in graficasV" :key="'v'+i">
        <sparkline-component v-bind="g" />
      </v-col>
    </v-row>

    <cartas-personalizadas :cartas="datosPagos" />
    <v-row class="mt-2 mb-8">
      <v-col cols="12" sm="6" lg="4" v-for="(g, i) in graficasP" :key="'p'+i">
        <sparkline-component v-bind="g" :esMoneda="true" />
      </v-col>
    </v-row>

    <cartas-personalizadas :cartas="datosVentas" />
    <v-row class="mt-2">
      <v-col cols="12" sm="6" lg="4" v-for="(g, i) in graficasVnt" :key="'vnt'+i">
        <sparkline-component v-bind="g" :esMoneda="true" />
      </v-col>
    </v-row>

    <v-overlay :value="cargando"><v-progress-circular indeterminate size="64" color="primary"></v-progress-circular></v-overlay>
  </div>
</template>

<script>
import HttpService from "../Servicios/HttpService";
import Utiles from "../Servicios/Utiles";
import CartasPersonalizadas from "./Dialogos/CartasPersonalizadas.vue";
import SparklineComponent from "./Dialogos/SparklineComponent.vue";

export default {
  name: "InicioComponent",
  components: { CartasPersonalizadas, SparklineComponent },
  data: () => ({
    cargando: false,
    nombreUsuario: localStorage.getItem("usuario") || "Admin",
    mesSeleccionado: new Date().getMonth() + 1,
    anioSeleccionado: new Date().getFullYear(),
    listaMeses: [
      { text: 'Enero', value: 1 }, { text: 'Febrero', value: 2 }, { text: 'Marzo', value: 3 },
      { text: 'Abril', value: 4 }, { text: 'Mayo', value: 5 }, { text: 'Junio', value: 6 },
      { text: 'Julio', value: 7 }, { text: 'Agosto', value: 8 }, { text: 'Septiembre', value: 9 },
      { text: 'Octubre', value: 10 }, { text: 'Noviembre', value: 11 }, { text: 'Diciembre', value: 12 }
    ],
    listaAnios: [],
    datosVisitas: [], datosPagos: [], datosVentas: [],
    etiquetasVisitasHora: [], valoresVisitasHora: [], etiquetasVisitasSemana: [], valoresVisitasSemana: [], etiquetasVisitasMes: [], valoresVisitasMes: [],
    etiquetasPagosSemana: [], valoresPagosSemana: [], etiquetasPagosMes: [], valoresPagosMes: [], etiquetasPagosMeses: [], valoresPagosMeses: [],
    etiquetasVentasSemana: [], valoresVentasSemana: [], etiquetasVentasMes: [], valoresVentasMes: [], etiquetasVentasMeses: [], valoresVentasMeses: [],
  }),
  computed: {
    graficasV() { return [
      { etiquetas: this.etiquetasVisitasHora, valores: this.valoresVisitasHora, color: 'pink darken-1', titulo: 'Visitas hoy', subtitulo: 'Por hora' },
      { etiquetas: this.etiquetasVisitasSemana, valores: this.valoresVisitasSemana, color: 'red darken-1', titulo: 'Visitas semana', subtitulo: 'Rendimiento 7 días' },
      { etiquetas: this.etiquetasVisitasMes, valores: this.valoresVisitasMes, color: 'indigo darken-1', titulo: 'Visitas mes', subtitulo: 'Actividad mensual' }
    ]},
    graficasP() { return [
      { etiquetas: this.etiquetasPagosSemana, valores: this.valoresPagosSemana, color: 'green darken-1', titulo: 'Pagos semana', subtitulo: 'Ingresos membresías' },
      { etiquetas: this.etiquetasPagosMes, valores: this.valoresPagosMes, color: 'orange darken-1', titulo: 'Pagos mes', subtitulo: 'Recaudación mensual' },
      { etiquetas: this.etiquetasPagosMeses, valores: this.valoresPagosMeses, color: 'blue darken-1', titulo: 'Pagos por meses', subtitulo: 'Crecimiento anual' }
    ]},
    graficasVnt() { return [
      { etiquetas: this.etiquetasVentasSemana, valores: this.valoresVentasSemana, color: 'orange darken-4', titulo: 'Ventas semana', subtitulo: 'Tienda' },
      { etiquetas: this.etiquetasVentasMes, valores: this.valoresVentasMes, color: 'deep-orange darken-1', titulo: 'Ventas mes', subtitulo: 'Recaudación tienda' },
      { etiquetas: this.etiquetasVentasMeses, valores: this.valoresVentasMeses, color: 'brown darken-1', titulo: 'Ventas por meses', subtitulo: 'Histórico productos' }
    ]}
  },
  mounted() { this.obtenerDatos(); },
  methods: {
    obtenerDatos() {
      this.cargando = true;
      HttpService.obtenerConDatos({ metodo: "obtener" }, "inicio.php").then((res) => {
        if (!res) return;
      
        this.crearCartas(res.datosVisitas, res.datosPagos, res.datosVentas);
        
        this.etiquetasVisitasHora = Utiles.obtenerClaves(res.visitasHora);
        this.valoresVisitasHora = Utiles.obtenerValores(res.visitasHora);
        const vSem = Utiles.prepararGraficaSemanal(res.visitasSemana, "numeroVisitas");
        this.etiquetasVisitasSemana = vSem.etiquetas; this.valoresVisitasSemana = vSem.valores;
        this.etiquetasVisitasMes = Utiles.obtenerClaves(res.visitasMes); this.valoresVisitasMes = Utiles.obtenerValores(res.visitasMes);

        const pSem = Utiles.prepararGraficaSemanal(res.pagosSemana, "total");
        this.etiquetasPagosSemana = pSem.etiquetas; this.valoresPagosSemana = pSem.valores;
        this.etiquetasPagosMes = Utiles.obtenerClaves(res.pagosMes); this.valoresPagosMes = Utiles.obtenerValoresPagos(res.pagosMes);
        const pMeses = Utiles.cambiarNumeroANombreMes(res.pagosMeses);
        this.etiquetasPagosMeses = Utiles.obtenerClaves(pMeses); this.valoresPagosMeses = Utiles.obtenerValoresPagos(pMeses);

        const vntSem = Utiles.prepararGraficaSemanal(res.ventasSemana, "total");
        this.etiquetasVentasSemana = vntSem.etiquetas; this.valoresVentasSemana = vntSem.valores;
        this.etiquetasVentasMes = Utiles.obtenerClaves(res.ventasMes); this.valoresVentasMes = Utiles.obtenerValoresPagos(res.ventasMes);
        const vntMeses = Utiles.cambiarNumeroANombreMes(res.ventasMeses);
        this.etiquetasVentasMeses = Utiles.obtenerClaves(vntMeses); this.valoresVentasMeses = Utiles.obtenerValoresPagos(vntMeses);
        
        this.cargando = false;
      }).catch(() => { this.cargando = false; });
    },

    crearCartas(visitas, pagos, ventas) {
      
      this.datosVisitas = [
        { color: "purple darken-1", icono: "mdi-account-group", nombre: "Total Visitas", total: visitas.totalVisitas },
        { color: "pink darken-1", icono: "mdi-account-check", nombre: "Hoy", total: visitas.visitasHoy },
        { color: "red darken-1", icono: "mdi-calendar-week", nombre: "Semana", total: visitas.visitasSemana },
        { color: "indigo darken-1", icono: "mdi-calendar-month", nombre: "Mes", total: visitas.visitasMes }
      ];
      this.datosPagos = [
        { color: "blue darken-1", icono: "mdi-cash-multiple", nombre: "Ingresos Totales", total: "S/ " + (pagos.totalPagos || 0) },
        { color: "teal darken-1", icono: "mdi-cash-today", nombre: "Pagos Hoy", total: "S/ " + (pagos.pagosHoy || 0) },
        { color: "green darken-1", icono: "mdi-cash-check", nombre: "Pagos Semana", total: "S/ " + (pagos.pagosSemana || 0) },
        { color: "orange darken-1", icono: "mdi-cash-register", nombre: "Pagos Mes", total: "S/ " + (pagos.pagosMes || 0) }
      ];
      this.datosVentas = [
        { color: "orange darken-4", icono: "mdi-store", nombre: "Ventas Totales", total: "S/ " + (ventas.totalVentas || 0) },
        { color: "deep-orange darken-1", icono: "mdi-cart-arrow-down", nombre: "Ventas Hoy", total: "S/ " + (ventas.ventasHoy || 0) },
        { color: "brown darken-1", icono: "mdi-calendar-check", nombre: "Ventas Mes", total: "S/ " + (ventas.ventasMes || 0) },
        { color: "blue-grey darken-3", icono: "mdi-tag-multiple", nombre: "Stock", total: (ventas.totalProductos || 0) }
      ];
    },

    async generarReporte(tipo, formato) {
      this.cargando = true;
      try {
        const payload = { metodo: "reporte_detallado", tipo, mes: this.mesSeleccionado, anio: this.anioSeleccionado };
        const res = await HttpService.obtenerConDatos(payload, "reportes.php");
        if (!res || !res.datos || res.datos.length === 0) {
            alert(`No hay registros para este periodo.`);
            this.cargando = false;
            return;
        }
        const columnas = tipo === 'Pagos' 
          ? [{text: 'MATRÍCULA', value: 'matricula'}, {text: 'PLAN', value: 'nombre_plan'}, {text: 'FECHA', value: 'fecha'}, {text: 'MONTO', value: 'monto'}]
          : [{text: 'TICKET', value: 'codigo_ticket'}, {text: 'FECHA', value: 'fecha'}, {text: 'CLIENTE', value: 'nombre_cliente'}, {text: 'TOTAL', value: 'total'}];
        const nMes = this.listaMeses.find(m => m.value === this.mesSeleccionado).text;
        const nombreDoc = `REPORTE_${tipo.toUpperCase()}_${nMes}_${this.anioSeleccionado}`;
        if(formato === 'excel') await Utiles.exportarExcel(nombreDoc, columnas, res.datos);
        else Utiles.exportarPDF(nombreDoc, columnas, res.datos);
      } catch (e) { console.error(e); } finally { this.cargando = false; }
    }
  }
};
</script>

<style scoped>
.deep-blue--text { color: #1B2559 !important; }
.bg-white { background-color: white !important; }
</style>


// WEBPACK FOOTER //
// src/components/InicioComponent.vue